import React from "react";

export const LoadingBar = () => (
  <div className="loading-bar" data-testid="loading-bar">
    <div className="loading-bar__trace" />
  </div>
);
